export class GcpRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "hostProjectId",
            "baseName": "hostProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "folderId",
            "baseName": "folderId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
